module.exports = __webpack_public_path__ + "img/einfachgast-with-slogan.1975f3d2.png";